module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"fr":{"see_more":"Voir plus"},"en":{"see_more":"See more"},"de":{"see_more":"Mehr anzeigen"},"es":{"see_more":"Ver más"},"it":{"see_more":"Vedi di più"},"nl":{"see_more":"Meer weergeven"},"pt":{"see_more":"See more"}}')
  delete Component.options._Ctor
}
